import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { CreateCredentialsComponent } from './components/create-credentials/create-credentials.component';
import { AccountInfoComponent } from './components/account-info/account-info.component';
import { UserComponent } from './components/user/user.component';
import { MapComponent } from './components/map/map.component';
import { ReportsComponent } from './components/reports/reports.component';
import { MapReportComponent } from './components/map-report/map-report.component';
import { NewReportComponent } from './components/new-report/new-report.component';
import { TripComponent } from './components/trip/trip.component';
import { ListUserComponent } from './components/management/list-user/list-user.component';
import { ListProjectComponent } from './components/management/list-project/list-project.component';
import { AnalysisReportComponent } from './components/management/analysis-report/analysis-report.component';
import { ManageMapComponent } from './components/management/manage-map/manage-map.component';
import { ReportComponent } from './components/management/report/report.component';
import { TripAnalysisComponent } from './components/management/trip-analysis/trip-analysis.component';
import { TripManagementComponent } from './components/management/trip/trip-management.component';
import { MainGuard } from './guards/main.guard';
import { ForgotPwdComponent } from './components/forgot-pwd/forgot-pwd.component';
import { EditTripComponent } from './components/management/edit-trip/edit-trip.component';
import { PublicMapComponent } from "./components/public-map/public-map.component";
import { SocialLoginComponent } from "./components/social-login/social-login.component";
import { AccountVerificationComponent } from './components/account-verification/account-verification.component';
import { GetStartComponent } from './components/get-started/get-started.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },

  {
    path: 'register',
    component: RegisterComponent
  },

  {
    path: 'register/create',
    component: CreateCredentialsComponent
  },

  {
    path: 'oauth2/redirect',
    component: SocialLoginComponent
  },

  {
    path: 'account/info',
    component: AccountInfoComponent,
    canActivate: [MainGuard],
  },
  {
    path: 'accountverification.html',
    component: AccountVerificationComponent
  },
  {
    path: 'ovmap/:project/:subproject',
    component: PublicMapComponent
  },
  {
    path: 'ovmap/:project',
    component: PublicMapComponent
  },
  {
    path: 'reset/password.html',
    component: ForgotPwdComponent
  },

  {
    path: '',
    component: UserComponent,
    canActivate: [MainGuard],
    children: [
      {
        path: '',
        component: MapComponent
      },
      {
        path: 'reports',
        component: ReportsComponent
      },
      {
        path: 'reports/map',
        component: MapReportComponent
      },
      {
        path: 'reports/:mode',
        component: NewReportComponent
      },
      {
        path: 'reports/:mode/:projectId/:id',
        component: NewReportComponent
      },
      {
        path: 'trips/:id',
        component: EditTripComponent,
        data: { role: 'user' }
      },
      {
        path: 'trips',
        component: TripComponent,
      },
      {
        path: 'management',
        children: [
          {
            path: 'report',
            children: [
              {
                path: '',
                component: ReportComponent
              },
              {
                path: 'map',
                component: MapReportComponent
              },
              {
                path: ':mode/:projectId/:id',
                component: NewReportComponent,
                data: { role: 'management' }
              },
              {
                path: 'analysis',
                component: AnalysisReportComponent
              }
            ]
          },
          {
            path: 'trip',
            children: [
              {
                path: '',
                component: TripManagementComponent
              },
              {
                path: 'edit/:id',
                component: EditTripComponent
              },
              {
                path: 'analysis',
                component: TripAnalysisComponent
              }
            ]
          },
          {
            path: 'map',
            component: ManageMapComponent
          },
          {
            path: 'projects',
            component: ListProjectComponent
          },
          {
            path: 'users',
            component: ListUserComponent
          },
        ]
      },
      {
        path: 'settings',
        loadChildren: './modules/settings/settings.module#SettingsModule'
      },
      {
        path: 'help',
        component: GetStartComponent
      }

    ],
    data: { skipGuard: false }
  },

  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full'
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
